import ActiveFiltersQuery from '@jetshop/core/components/DynamicRoute/ActiveFiltersQuery.gql';
import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import PaginationProvider, { usePagination } from '@jetshop/core/components/Pagination/PaginationProvider';
import throwErrorInDev from '@jetshop/core/helpers/throwErrorInDev';
import { useFilters } from '@jetshop/core/hooks/Filters/useFilters';
import qs from 'qs';
import * as React from 'react';
import { Query, useQuery } from 'react-apollo';
const SearchPageBehaviour = props => {
    var _a;
    const pagination = usePagination();
    const { location, searchQuery, children } = props;
    const { offset, perPage } = React.useContext(PaginationContext);
    const activeSearchTerm = React.useRef();
    // Track the previous offset. If it has changed, we're paginating. If it
    // hasn't, we're just applying filters.
    const activeOffset = React.useRef(0);
    const { clearAllFilters } = useFilters();
    throwErrorInDev(!searchQuery, `You did not pass 'searchQuery' to SearchPageBehaviour`);
    const activeFilterQuery = useQuery(ActiveFiltersQuery);
    const searchTerm = React.useMemo(() => qs.parse(location.search, { ignoreQueryPrefix: true }).term, [location]);
    React.useEffect(() => {
        if (activeSearchTerm.current && activeSearchTerm.current !== searchTerm) {
            clearAllFilters();
        }
        activeSearchTerm.current = searchTerm;
    }, [clearAllFilters, searchTerm]);
    React.useEffect(() => {
        activeOffset.current = offset;
    }, [offset]);
    if (pagination === undefined) {
        return (React.createElement(PaginationProvider, null,
            React.createElement(SearchPageBehaviour, Object.assign({}, props))));
    }
    // Ideally this component would use the data from usePagination, but due to
    // how the shouldComponentUpdate method in FilterContainer works it prevents
    // rendering if we don't do it this way.
    return searchTerm ? (React.createElement(Query, { variables: {
            term: searchTerm,
            first: perPage,
            limit: perPage,
            filters: ((_a = activeFilterQuery.data) === null || _a === void 0 ? void 0 : _a.activeFilters) || null,
            offset: activeOffset.current === offset ? 0 : offset,
            client: !__IN_SERVER__
        }, query: searchQuery, fetchPolicy: "cache-and-network" }, (result) => {
        var _a, _b, _c, _d, _e, _f;
        const totalResults = (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.search) === null || _b === void 0 ? void 0 : _b.products) === null || _c === void 0 ? void 0 : _c.totalResults;
        const filters = (_f = (_e = (_d = result === null || result === void 0 ? void 0 : result.data) === null || _d === void 0 ? void 0 : _d.search) === null || _e === void 0 ? void 0 : _e.products) === null || _f === void 0 ? void 0 : _f.filters;
        return (React.createElement(React.Fragment, null, children({
            result,
            total: totalResults,
            filters,
            term: searchTerm,
            loading: result.loading,
            error: result.error
        })));
    })) : (children({
        term: searchTerm,
        loading: false,
        error: null,
        total: 0,
        result: {},
        filters: {}
    }));
};
export default SearchPageBehaviour;
//# sourceMappingURL=SearchPageBehaviour.js.map